exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clothing-admin__compact-row {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.clothing-admin__compact-row .clothing-admin__field {\r\n  margin-bottom: 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing-admin-department-marker.component.css
// module id = ../../../../../src/app/content-page/admin/clothing/clothing-admin-department-marker.component.css
// module chunks = main